import Footer from "components/Footer/Footer";
import Header from "components/Header/Header";
import React, { useMemo, useState } from "react";
import { Col, Container, Row, Button, Form } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import uplodimg from "../../../src/assets/images/upload.png";
import adverisebanner from "../../../src/assets/images/advertise-big-img.png";
import advertisesmall from "../../../src/assets/images/advertisesmall.svg";
import personwithdron from "../../../src/assets/images/person-with-dron.png";
import { utilService } from "services";
import * as Yup from "yup";
import { useFormik } from "formik";
import useCountries from "hooks/useCountries";
import { sponsorService } from "services/sponsor.service";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import useCurrentUser from "hooks/useCurrentUser";
import AdvertisementConfirmation from "components/Modals/Alertpopus/AdvertismentConfirmation";



const AdvertiseSchema = Yup.object().shape({
  firstName: Yup.string()
    .required("Please enter first name")
    .max(15, "First Name must be at most 15 characters"),
  lastName: Yup.string()
    .required("Please enter last name")
    .max(15, "Last Name must be at most 15 characters"),
  email: Yup.string()
    .required("Please enter email")
    .email("Enter valid email")
    .matches(
      /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
      "Enter valid email"
    ),
  phone: Yup.string()
    .required("Please enter phone number")
    .matches(/^\d{10}$/, "Please enter a valid 10-digit phone number"),
  link: Yup.string().required("Please enter Link address"),
  description: Yup.string().required("Please enter Description"),
  banner: Yup.string().required("Please upload file"),
  size: Yup.string().required("Please enter size"),
});

function Advertise() {
  const [error, setError] = useState(null);
  const [size, setSize] = useState("Small");
  const [isShowConfirmation, setShowConfirmation] = useState(false)
  const { countries } = useCountries();
  const navigate = useNavigate();
  const { user } = useCurrentUser();
  const [profilePreview, setProfilePreview] = useState("");
  const [fileNames, setFileNames] = useState({});

  const initialValues = {
    firstName: user?.firstName || "",
    lastName: user?.lastName || "",
    email: user?.email || "",
    countryCode: "+1",
    phone: user?.phone || "",
    link: "",
    description: "",
    banner: "",
    size: "",
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: AdvertiseSchema,
    onSubmit: async (values) => {
      try {
        const response = await sponsorService.addSponsor(values);
        if (response?.data?.success) {
          toast.success(response?.data?.message);
          formik.resetForm();
          setShowConfirmation(true)
          // navigate("/");
        } else {
          toast.danger(response?.data?.message);
        }
      } catch (err) {
        console.error(err?.response?.data?.message);
        setError(err?.response?.data?.message);
      }
    },
  });

  const handleFileUpload = async (e) => {
    if (!formik?.values?.size) {
      formik.setErrors({
        ...formik.errors,
        banner: "Please Select Advertisement Size before uploading file",
      });
      e.target.value = "";
      return;
    }
    const file = e.target.files[0];
    const extension = file.name.split(".").pop();
    if (!["png", "jpg", "jpeg"].includes(extension.toLowerCase())) {
      formik.setErrors({
        ...formik.errors,
        banner: "Invalid file type. Please select a PNG, JPG, or JPEG file.",
      });
      return;
    }
    try {
      const response = await utilService.getBucketUrl({
        location: "users/",
        extension,
      });
      const webUrlData = response.data.data[0];
      const { filename, preview, url } = webUrlData || {};

      const requestOptions = {
        method: "PUT",
        headers: {
          "Content-Type": file.type,
        },
        body: file,
        redirect: "follow",
      };

      const result = await utilService.uploadFile({
        url,
        requestOptions,
      });

      if (result.ok) {
        if (e.target.name === "avatar") {
          setProfilePreview(preview);
        }
        const img = new Image();
        img.src = preview;

        img.onload = () => {
          const width = img.width;
          const height = img.height;

          if (
            formik.values.size === "Large" &&
            (width !== 550 || height !== 250)
          ) {
            formik.setErrors({
              ...formik.errors,
              banner:
                'Image must have dimensions of 550x250 for the "Large" option.',
            });
          } else if (
            formik.values.size === "Small" &&
            (width !== 360 || height !== 165)
          ) {
            formik.setErrors({
              ...formik.errors,
              banner:
                'Image must have dimensions of 360x165 for the "Small" option.',
            });
          }
        };

        formik.setFieldValue(e.target.name, filename);
        setFileNames({
          ...fileNames,
          [e.target.name]: file.name,
        });
      } else {
        console.error("File upload failed");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handlePhoneChange = (value) => {
    const digitsOnly = value.replace(/\D/g, "");
    const phoneNumber = digitsOnly.startsWith("1") ? digitsOnly.slice(1) : digitsOnly;
    formik.setFieldValue("phone", phoneNumber);
    formik.setFieldValue("countryCode", "+1");
  };


  const { values, getFieldProps, handleSubmit, touched, errors } = formik

  return (
    <>
      <div className="advertise-page">
        <Container>
          <Row>
            <form className="d-flex flex-wrap justify-content-center">
              <Col xl={{ span: 5, order: 1 }} xs={{ span: 12, order: 2 }}>
                <div className=" advertise-card">
                  <h2 className="advertise-section-heading">Advertise with us!</h2>
                  <h5 className="advertise-sub-heading mobile-sub-heading">
                    Fill the details
                  </h5>
                  <div className="form-div">
                    <div className="row">
                      <div className="col-lg-6 mb-30 text-left">
                        <label className="py-2">First Name</label>

                        <input
                          type="text"
                          placeholder="Enter First Name"
                          className="form-control w-100"
                          {...getFieldProps('firstName')}
                        />
                        {touched.firstName && errors.firstName ? (
                          <span className="text-danger">
                            {errors.firstName}
                          </span>
                        ) : null}
                      </div>
                      <div className="col-lg-6 mb-30 text-left">
                        <label className="py-2">Last Name</label>

                        <input
                          type="text"
                          placeholder="Enter Last Name"
                          className="form-control w-100"
                          {...getFieldProps('lastName')}
                        />
                        {touched.lastName && errors.lastName ? (
                          <span className="text-danger">
                            {errors.lastName}
                          </span>
                        ) : null}
                      </div>
                    </div>

                    <div className="mb-30 text-left">
                      <label className="py-2">Email</label>

                      <input
                        type="text"
                        placeholder="Enter Email"
                        className="form-control w-100"
                        {...getFieldProps('email')}
                      />
                      {touched.email && errors.email ? (
                        <span className="text-danger">{errors.email}</span>
                      ) : null}
                    </div>

                    <div className="mb-30 text-left">
                      <label className="py-2">Mobile Number</label>

                      <PhoneInput
                        country="us"
                        onlyCountries={["us"]}
                        disableDropdown={true}
                        countryCodeEditable={false}
                        placeholder="Enter phone number"
                        name="phone"
                        id="phone-field"
                        onChange={handlePhoneChange}
                        onBlur={formik.handleBlur}
                        value={`${values.countryCode}${values.phone}`}
                      />
                      {touched.phone && errors.phone ? (
                        <span className="text-danger">{errors.phone}</span>
                      ) : null}
                    </div>

                    <div className="mb-30 text-left">
                      <label className="py-2">Link</label>

                      <input
                        type="url"
                        placeholder="Enter Link Address"
                        className="form-control w-100"
                        name="link"
                        {...getFieldProps('link')}
                      />
                      {touched.link && errors.link ? (
                        <span className="text-danger">{errors.link}</span>
                      ) : null}
                    </div>

                    <div className="mb-30 text-left">
                      <label className="py-2">Description</label>
                      <div className="textrea-overlay w-100">
                        <textarea
                          className="form-control w-100 textarea-height193"
                          placeholder="Enter Description"
                          {...getFieldProps('description')}
                          maxLength={1000}
                        ></textarea>
                      </div>

                      <label className="d-block text-end pt-1 pe-1">
                        {values?.description.length}/1000
                      </label>
                      {touched.description && errors.description ? (
                        <span className="text-danger">
                          {errors.description}
                        </span>
                      ) : null}
                    </div>
                    <div className="upload-card">
                      <label className="uploadFile">
                        <img alt="" src={uplodimg} />
                        <p>
                          {formik.values.banner
                            ? fileNames?.banner
                            : "Upload File"}
                        </p>
                        <input
                          type="file"
                          className="inputfile form-control"
                          name="banner"
                          onChange={handleFileUpload}
                          onBlur={formik.handleBlur}
                          accept=".png, .jpg, .jpeg"
                        />
                      </label>
                      {formik.touched.banner && formik.errors.banner ? (
                        <span className="text-danger">
                          {formik.errors.banner}
                        </span>
                      ) : null}
                    </div>

                    <div className="text-center">
                      <Button
                        type="submit"
                        disabled={formik.isSubmitting}
                        onClick={formik.handleSubmit}
                        className="btn btn-primary w-100 mt-0"
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xl={{ span: 7, order: 2 }} xs={{ span: 12, order: 1 }}>
                <div className="advertise-right-div d-flex flex-column">
                  <h5 className="advertise-headline-right">
                    Select Advertisement Size
                  </h5>
                  <div className="ms-0">
                    <div className="advertise-size-div align-items-center d-flex flex-column">
                      <div className="advertise-banner-div">
                        <img
                          src={adverisebanner}
                          className="advertise-big-banner-img"
                          alt="Large Banner"
                        />
                      </div>
                      <div className="form-check radio-design mx-auto">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="size"
                          id="flexCheckDefault"
                          onChange={(e) => {
                            if (e.target.checked) {
                              formik.setFieldValue("size", "Large");
                              formik.setFieldValue("banner", "");
                              setFileNames({});
                              setProfilePreview("");
                            }
                          }}
                          checked={formik.values.size === "Large"}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexCheckDefault"
                        >
                          Large
                        </label>
                      </div>
                    </div>
                    <div className="advertise-size-div align-items-center d-flex flex-column">
                      <div className="advertise-banner-div">
                        <img
                          src={advertisesmall}
                          className="advertise-small-banner-img"
                          alt="Small Banner"
                        />
                      </div>
                      <div className="form-check radio-design">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="size"
                          id="flexCheckDefault2"
                          onChange={(e) => {
                            if (e.target.checked) {
                              formik.setFieldValue("size", "Small");
                              formik.setFieldValue("banner", "");
                              setFileNames({});
                              setProfilePreview("");
                            }
                          }}
                          checked={formik.values.size === "Small"}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexCheckDefault2"
                        >
                          Small
                        </label>
                      </div>
                    </div>
                  </div>
                  <img src={personwithdron} className="person-with-dron" alt="Person with Dron" />
                </div>
              </Col>

            </form>
          </Row>
        </Container>
      </div>
      <AdvertisementConfirmation show={isShowConfirmation} handleClose={() => {
        navigate('/')
      }} />
    </>
  );
}

export default Advertise;